<div style="margin-left: 4%; margin-right: 4%;">
  <div style="margin-top: 1.875rem">
    <span class="fundingProjectHeader">Charging Project - Estimate</span>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="display: inline-block; margin-top: 1.563rem; margin-left: 1.563rem;">
    <mat-form-field class="fundingFields" style="pointer-events: none; width: 12.5rem;">
      <input [(ngModel)]="fundingProjectID" placeholder="Funding Project ID" matInput>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem;">
    <mat-form-field class="fundingFields" style="pointer-events: none; width: 31.25rem;">
      <input [(ngModel)]="projectName" placeholder="Project Name" matInput>
    </mat-form-field>
  </div>
  <div style="display: inline-block; margin-left: 2.5rem;">
    <mat-form-field class="fundingFields" style="pointer-events: none; width: 23.313rem;">
      <input [(ngModel)]="projectChargeIndicator" placeholder="Project Charge Indicator" matInput>
    </mat-form-field>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="margin-left: 2.063rem;">
    <div style="font-size: 0.75rem; color: #676767; margin-bottom: 0.25rem;">Asset Location</div>
    <textarea readonly [(ngModel)]="assetLocation.long_description" class="longDescriptionTextBox"></textarea>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="margin-top: 2.2rem; margin-left: 2.063rem;">
    <div style="color: #696969; font-weight: 700;">Project Estimate Details</div>
  </div>
</div>
<div style="background-color: #f3fafd; width: 76.563rem; margin-left: 1.75rem;">
  <div style="margin-left: 1.438rem; margin-top: 1rem;">
    <div style="width: 8.688rem; display: inline-block; margin-top: 2.642rem;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Function</span>
    </div>
    <div style="width: 10rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Utility Account</span>
    </div>
    <div style="width: 9.125rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Retirement Unit</span>
    </div>
    <div style="width: 15.375rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Charge Type</span>
    </div>
    <div style="width: 6.688rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Quantity</span>
    </div>
    <div style="width: 15.438rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Asset Location</span>
    </div>
    <div style="width: 9.813rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Estimated Costs</span>
    </div>
  </div>
  <div style="background-color: #696969; height: 0.05rem; margin-left: 1.5rem; margin-top: 0.3rem; margin-right: 1.5rem;"></div>
  <div *ngFor="let projectEstimate of projectEstimates; let i = index" style="margin-left: 1rem">
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 7.5rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Function</mat-placeholder>
        <mat-select [compareWith]="compareProjectFunction" [(value)]="projectEstimate.projectFunction"
          (selectionChange)="functionChanged(i); getUtilityAccount($event.value, i);"
          [disabled]="functionDisabled()">
          <mat-select-trigger *ngIf="projectEstimate.projectFunction">
            <span class="dropdownText">{{projectEstimate.projectFunction.description}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let projectFunction of functions" style="color: #696969" [value]="projectFunction"><span class="dropdownText">{{projectFunction.description}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 9.125rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Utility Account</mat-placeholder>
        <mat-select [compareWith]="compareUtilityAccount" [(value)]="projectEstimate.utilityAccount"
          (selectionChange)="utilityAccountChanged(i); getRetirementUnit($event.value, i);"
          [disabled]="utilityAccountDisabled(i)">
          <mat-select-trigger *ngIf="projectEstimate.utilityAccount">
            <span class="dropdownText">{{projectEstimate.utilityAccount.util_account_descr}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let account of projectEstimate.utilityAccountOptions" style="color: #696969" [value]="account"><span class="dropdownText">{{account.util_account_descr}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 8.125rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Retirement Unit</mat-placeholder>
        <mat-select [compareWith]="compareRetirementUnit" [(value)]="projectEstimate.retirementUnit"
          (selectionChange)="retirementUnitChanged(i); getUnit($event.value, i);"
          [disabled]="retirementUnitDisabled(i)">
          <mat-select-trigger *ngIf="projectEstimate.retirementUnit">
            <span class="dropdownText">{{projectEstimate.retirementUnit.retirement_unit_descr}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let unit of projectEstimate.retirementUnitOptions" style="color: #696969" [value]="unit"><span class="dropdownText">{{unit.retirement_unit_descr}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 14.375rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Charge Type</mat-placeholder>
        <mat-select [(value)]="projectEstimate.chargeType"
          (selectionChange)="chargeTypeChanged(i)"
          [disabled]="chargeTypeDisabled(i)">
          <mat-select-trigger *ngIf="projectEstimate.chargeType">
            <span class="dropdownText">{{projectEstimate.chargeType.chg_type_descr}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let type of chargeTypes" style="color: #696969" [value]="type"><span class="dropdownText">{{type.chg_type_descr}}</span></mat-option>
        </mat-select>
      </mat-form-field>
      <div [class.hideElement]="!chargeTypeIsMaterial(i)" style="position: relative">
        <span style="position: absolute; top: -1.188rem; font-size: 0.688rem; left: 0.5rem;" *ngIf="projectEstimate.unitReminder">{{projectEstimate.unitReminder.uom_reminder}}</span>
      </div>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 5.688rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Quantity</mat-placeholder>
        <input class="dropdownText" type="number" min="0" [(ngModel)]="projectEstimate.quantity"
          [disabled]="!chargeTypeIsMaterial(i)" matInput>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 14.438rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Asset Location</mat-placeholder>
        <mat-select [compareWith]="compareAssetLocation" [(value)]="projectEstimate.assetLocation">
          <mat-select-trigger *ngIf="projectEstimate.assetLocation">
            <span class="dropdownText">{{projectEstimate.assetLocation.long_description}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let location of assetLocationOptions" style="color: #696969" [value]="location"><span class="dropdownText">{{location.long_description}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 8.313rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Estimated Costs</mat-placeholder>
        <input class="dropdownText" type="number" min="0" step=".01" [(ngModel)]="projectEstimate.estimatedCosts" matInput>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <img (click)="deleteEstimate()" src="assets/trash-bin.svg" style="cursor: pointer; width: 0.75rem;">
    </div>
  </div>
  <div style="padding-top: 1.438rem; padding-left: 1rem;">
    <div (click)="addNewEstimate()" style="cursor: pointer; width: 11.5rem;">
      <span style="font-size: 1.3rem; font-weight: 700;">+</span>
      <span style="text-decoration: underline; text-underline-offset: 0.313rem; font-size: 0.875rem;">ADD NEW ESTIMATE LINE</span>
    </div>
  </div>
  <div style="text-align: right; padding-right: 3.125rem;">
    <span style="color: #696969">Total Estimated:</span>
  </div>
  <div style="text-align: right; padding-right: 3.125rem; padding-bottom: 2rem;">
    <span style="color: #696969; font-weight: 700;">${{estimateTotal()}}</span>
  </div>
</div>
<div style="margin-left: 3.2%">
  <div style="margin-top: 2.2rem; margin-left: 2.063rem;">
    <div style="color: #696969; font-weight: 700;">Capital Retirements Details</div>
  </div>
</div>
<div style="background-color: #f3fafd; width: 76.563rem; margin-left: 1.75rem;">
  <div style="margin-left: 1.438rem; margin-top: 1rem;">
    <div style="width: 23.25rem; display: inline-block; margin-top: 2.642rem;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Utility Account Being Removed</span>
    </div>
    <div style="width: 15.188rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Retirement Unit</span>
    </div>
    <div style="width: 10.438rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Original Installed Year</span>
    </div>
    <div style="width: 6.005rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Quantity</span>
    </div>
    <div style="width: 20.126rem; display: inline-block;">
      <span style="font-size: 0.875rem; font-weight: 700; color: #696969;">Address ( Optional )</span>
    </div>
  </div>
  <div style="background-color: #696969; height: 0.05rem; margin-left: 1.5rem; margin-top: 0.3rem; margin-right: 1.5rem;"></div>
  <div *ngFor="let capitalRetirement of capitalRetirements; let i = index" style="margin-left: 1rem">
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 22.2rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Utility Account Being Removed</mat-placeholder>
        <mat-select [(value)]="capitalRetirement.utilityAccountBeingRemoved"
          [disabled]="utilityAccountRemovalDisabled()"
          (selectionChange)="utilityAccountForRemovalChanged(i); getRetirementUnitCapital($event.value, i)">
          <mat-select-trigger *ngIf="capitalRetirement.utilityAccountBeingRemoved">
            <span class="dropdownText">{{capitalRetirement.utilityAccountBeingRemoved.util_account_descr}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let account of utilityAccountsForRemoval" style="color: #696969" [value]="account"><span class="dropdownText">{{account.util_account_descr}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 14.125rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Retirement Unit</mat-placeholder>
        <mat-select [(value)]="capitalRetirement.retirementUnit"
          [disabled]="capitalRetirementUnitDisabled(i)">
          <mat-select-trigger *ngIf="capitalRetirement.retirementUnit">
            <span class="dropdownText">{{capitalRetirement.retirementUnit.retirement_unit_descr}}</span>
          </mat-select-trigger>
          <mat-option *ngFor="let unit of capitalRetirement.retirementUnitOptions" style="color: #696969" [value]="unit"><span class="dropdownText">{{unit.retirement_unit_descr}}</span></mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 9.4rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Original Installed Year</mat-placeholder>
        <input class="dropdownText" type="number" [max]="getCurrentYear()" step="1"
          [(ngModel)]="capitalRetirement.originalInstalledYear" matInput>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 5.1rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Quantity</mat-placeholder>
        <input class="dropdownText" type="number" min="0"
          [(ngModel)]="capitalRetirement.quantity" matInput>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <mat-form-field class="fundingFields" style="width: 18.2rem;" [floatLabel]="'never'">
        <mat-placeholder class="dropdownText">Address ( Optional )</mat-placeholder>
        <input class="dropdownText" [(ngModel)]="capitalRetirement.address" matInput>
      </mat-form-field>
    </div>
    <div style="display: inline-block">
      <img (click)="deleteCapitalRetirement()" src="assets/trash-bin.svg" style="cursor: pointer; width: 0.75rem;">
    </div>
  </div>
  <div style="padding-top: 1.438rem; padding-left: 1rem; padding-bottom: 2.5rem;">
    <div (click)="addCapitalRetirement()" style="cursor: pointer; width: 11.5rem;">
      <span style="font-size: 1.3rem; font-weight: 700;">+</span>
      <span style="text-decoration: underline; text-underline-offset: 0.313rem; font-size: 0.875rem;">ADD NEW RETIREMENT</span>
    </div>
  </div>
  <div style="display: block; padding-top: 6.875rem; padding-bottom: 2.5rem; background: white">
    <div style="display: inline-block; margin-left: 1.438rem;">
      <div class="exitButton" (click)="exitPage()">
        <span class="exitText">EXIT</span>
      </div>
    </div>
    <div style="display: inline-block; float: right;">
      <button class="confirmButton" [disabled]="submittingEstimate || submissionDisabled()" [class.buttonDisabled]="submittingEstimate || submissionDisabled()" 
        (click)="saveAndSubmit()">
        <span *ngIf="!submittingEstimate" class="confirmText">SUBMIT</span>
        <div *ngIf="submittingEstimate" class="dot-spin" style="margin: auto"></div>
      </button>
    </div>
  </div>
</div>